export const directivePrefix: string = 'wp';
